import * as endPoints from "../../constants/v2/endPoints";
import * as apiService from "./apiService";

export async function createSupportTicket(payload) {
  return await apiService.apiCallWithoutToken(
    endPoints.CREATE_SUPPORT_TICKET,
    "POST",
    payload
  );
}

export async function getSupportUploadUrls(payload) {
  return await apiService.apiCallWithoutToken(
    endPoints.SUPPORT_UPLOAD_URLS,
    "POST",
    payload
  );
}
